import { environment } from "src/environments/environment";
export class Constants {
    public static apiRoot = environment.apiRoot;
    public static clientRoot = environment.clientRoot;
    public static idpAuthority = environment.idpAuthority;
    public static clientId = environment.clientId;
}
